import React from "react";
import { default as WListItem } from "@mui/material/ListItem";

function ListItem(props) {
  return <WListItem {...props} />;
}

export default ListItem;
